<template>
  <div
    class="card-item options-api"
    :class="{
      'card-item-search': smallCards && !cardSizeReorder,
      'card-item-reorder': smallCards && cardSizeReorder,
      mb0: isOnCartPage,
    }"
    ref="productCard"
    v-if="!isOnCartPage || (quantity > 0 && isValid) || !isValid"
  >
    <div
      class="card-wrap"
      :class="{
        w100:
          clientPlatform == 'Web' &&
          (isOnCartPage || smallCards) &&
          !cardSizeReorder,
        'border-none': isLastInvalidItem,
        'd-flex justify-content-between card-wrap-cart': isOnCartPage,
        'variant-no-padding': variantNoPadding,
      }"
    >
      <div
        class="card-size"
        :class="{
          'card-rounded': cardRounded,
        }"
        v-if="!hideProductImg && !cardSizeReorder"
      >
        <div
          class="c-img-wrap"
          :class="{ 'opacity-60': outOfStock }"
          @click="$emit('updateShowProductCardInModal')"
        >
          <lazy-image
            class="card-img img-product-home"
            :class="{ 'grayscale-100': outOfStock }"
            alt="default image"
            :src="imageSrc"
            :src-placeholder="getPlaceHolderImg"
            @click="$emit('updateShowProductCardInModal')"
            loading="lazy"
            @error="handleImageError"
          />
          <img
            v-if="smallCards && !isOnCartPage"
            :src="[
              isVeg
                ? staticImgBaseUrl + '/images/global/tag-veg.svg'
                : staticImgBaseUrl + '/images/global/tag-non-veg.svg',
            ]"
            class="mr8 veg-nogveg"
            :class="[outOfStock ? 'opacity-60' : '']"
            loading="lazy"
            @error="handleImageError"
            alt="default image"
          />
        </div>

        <div
          class="card-content"
          @click="$emit('updateShowProductCardInModal')"
        >
          <div class="at-top" v-if="!smallCards">
            <div class="" v-if="!isInModal">
              <div class="tag-wrap tag-blue" v-if="bestsellerTag">
                <span class="tag color-slaty-dark">Bestseller</span>
                <div class="triangle-b-left"></div>
              </div>
              <div class="tag-wrap tag-blue" v-if="newTag">
                <span class="tag color-slaty-dark">New</span>
                <div class="triangle-b-left"></div>
              </div>
            </div>

            <div
              class="fav-wrap dt-hand"
              @click.stop="$emit('updateFavourite')"
            >
              <!-- use class 'hkfi-heart-filled' for favourited item -->
              <i
                class="hkfi-favourite-icon"
                :class="{ 'hkfi-heart-filled': isFavourite }"
              ></i>
            </div>
          </div>
        </div>
      </div>

      <div
        class="card-size"
        :class="{
          'card-rounded': cardRounded,
          'card-size-reorder': cardSizeReorder,
        }"
        v-else-if="!hideProductImg && cardSizeReorder"
      >
        <div
          class="c-img-wrap"
          :class="{ 'opacity-60': outOfStock }"
          :style="{
            backgroundImage: `url('${imageSrc}')`,
            backgroundSize: 'contain',
          }"
          @click="$emit('updateShowProductCardInModal')"
        ></div>
        <img
          :src="[
            isVeg
              ? staticImgBaseUrl + '/images/global/tag-veg.svg'
              : staticImgBaseUrl + '/images/global/tag-non-veg.svg',
          ]"
          class="mr8 veg-nogveg"
          :class="[outOfStock ? 'opacity-60' : '']"
          v-if="cardSizeReorder"
          loading="lazy"
          @error="handleImageError"
          alt="default image"
        />
      </div>

      <div
        class="at-botm flex-column jcsb"
        :class="{
          'card-botm-gradient': !smallCards,
          pl0: hideProductImg,
          'at-botm-cart': isOnCartPage,
        }"
      >
        <!-- extra info -->
        <div class="extra-info">
          <!-- modal for customization -->

          <!-- modal tobe shown, if quantity > 0 and then clicked on customisation btn -->

          <!-- customization disbale button modal -->

          <!-- modal tobe shown, if quantity > 0 and then clicked on Add/Minus Cta btn -->
        </div>

        <!-- item title and desc -->
        <div class="product-info">
          <div class="d-flex">
            <i
              class="mt3"
              :class="[
                isVeg ? 'tag-veg' : 'tag-non-veg',
                outOfStock ? 'opacity-60' : '',
                smallCards ? 'mr5' : 'size-16 mr8',
              ]"
              v-if="!cardSizeReorder && (!smallCards || isOnCartPage)"
            ></i>
            <span
              class="popular-menu-header medium"
              :class="{
                'opacity-60': outOfStock,
                'fs-12': smallCards,
                'fs-14': !smallCards,
              }"
              >{{ displayName }}</span
            >
          </div>
          <!-- <h3 :class="showFullInfo? 'product-desc-info-popup lh18':'product-desc lh18'"> -->
          <span
            class="bg-yellow pl10 pr10 br4 fs-10"
            v-if="outOfStock && !isOnCartPage"
            >Out of Stock</span
          >
          <h3
            v-if="!isOnCartPage"
            class="product-desc lh16"
            :class="{ 'product-full-desc': isInModal }"
          >
            {{ description }}
          </h3>
          <h3 v-if="productAttributes?.length" class="color-slaty fs-11 pl19">
            <span>{{ productAttributes?.[1]?.value }}</span
            ><span
              v-if="
                productAttributes?.[1]?.value && productAttributes?.[0]?.value
              "
            >
              |
            </span>
            <span>{{ productAttributes?.[0]?.value }}</span>
          </h3>
          <!-- savings text-->
          <span
            class="color-green-medium pl19 block fs-11"
            v-if="savingAmt && isComboItem"
            >Saving <i class="rs">Rs.</i>{{ savingAmt }} with this Combo!</span
          >
          <span
            class="color-green-medium pl19 block fs-11"
            v-else-if="savingAmt"
            >Saving <i class="rs">Rs.</i>{{ savingAmt }} with this
            Product!</span
          >
          <!-- edit flow for customizable non combo item -->
          <div
            class="combo-items-info pl19"
            v-if="smallCards && !isComboItem && isCustomizable && isOnCartPage"
          >
            <div>
              <span
                class="color-teal-primary fs-11 hand d-flex edit-text"
                @click="$emit('updateCartCustItem')"
                >Edit<i
                  class="hkfi-arrow-line rotate90clockwise pl15 arrow-address fs-10"
                ></i
              ></span>
            </div>
          </div>
          <!-- combo specific ui, will only be shown for combo item AND smallCards prop is true -->
          <div
            class="combo-items-info pl19"
            v-if="smallCards && isComboItem && isOnCartPage"
          >
            <!-- this will repeat -->
            <ul
              class="fs-11 lh18"
              :class="[outOfStock ? 'color-light-grey' : 'color-slaty']"
              v-for="(
                comboVariantName, comboVariantNameIndex
              ) in selectedComboVariants"
              :key="comboVariantNameIndex"
            >
              <li
                :class="[
                  outOfStock ||
                  outOfStockComboVariants.includes(comboVariantName)
                    ? 'color-light-grey'
                    : 'color-slaty',
                ]"
              >
                <div class="d-flex justify-content-between">
                  <span
                    :class="{
                      'opacity-60':
                        outOfStockComboVariants.includes(comboVariantName),
                    }"
                    >{{ comboVariantName }} x 1
                  </span>
                  <span
                    v-if="
                      outOfStockComboVariants.includes(comboVariantName) &&
                      !isOnCartPage
                    "
                    class="bg-yellow plr7 br4 fs-9 color-slaty-dark"
                    >Out of Stock</span
                  >
                </div>
              </li>
            </ul>
          </div>

          <!-- <div>
            <button
              class="remove-invalid-items d-flex bold pl24"
              @click="showComboDetails()"
              v-if="isOnCartPage && isComboItem"
            >
              {{ showOrHideDetailsText }}
              <i
                class="hkfi-arrow-line pl16"
                :class="[
                  showDetails
                    ? 'rotate90antiClockwise arrow-address-btm'
                    : 'rotate90clockwise arrow-address',
                ]"
              ></i>
            </button>
          </div> -->

          <div v-if="smallCards && isComboItem && isOnCartPage">
            <span
              class="color-teal-primary fs-11 hand pl19 d-flex edit-text"
              :class="[outOfStock ? 'disabled' : '']"
              @click="$emit('updateCartCustItem')"
              >Edit<i
                class="hkfi-arrow-line rotate90clockwise pl15 arrow-address fs-10"
              ></i
            ></span>
          </div>
        </div>

        <!-- product price and Add cta -->
        <div
          class="selected-info"
          :class="{ 'opacity-60': outOfStock }"
          v-if="!outOfStock && !isOnCartPage"
        >
          <div class="selections disp-col-inline">
            <div
              v-if="currentPrice === 0 || !currentPrice"
              class="width10 hide-shimmer-text shimmer-container rounded"
            >
              price
            </div>
            <div v-else>
              <div
                class="product-price disp-col-inline"
                v-if="currentPrice === regularPrice"
              >
                <i class="rs" v-if="currentPrice != 'Free'">Rs.</i>
                <span>
                  {{ currentPrice }}
                </span>
              </div>
              <div class="product-price disp-col-inline" v-else>
                <i class="rs" v-if="currentPrice != 'Free'">Rs.</i>
                <span>
                  {{ currentPrice }}
                </span>

                <div
                  class="pl5 strk-top tr"
                  v-if="regularPrice && regularPrice > currentPrice"
                >
                  <span class="color-grey fs-10 normal">
                    <i class="rs">Rs.</i
                    ><span class="striked-text"> {{ regularPrice }} </span>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="main-cta">
            <div v-if="quantity > 0" class="btn cta-edit medium">
              <span
                class="anim-ico-minus item-status-anim"
                @click="$emit('removefromcart')"
              >
              </span>
              <span class="bg-white item-quantity">{{ quantity }}</span>
              <span
                class="anim-ico-plus item-status-anim"
                @click="!outOfStock && $emit('addtocart')"
              ></span>
            </div>

            <button
              v-if="quantity === 0 && !outOfStock"
              class="btn medium bold hand cta-add"
              @click="$emit('addtocart')"
            >
              Add <span class="anim-ico-plus item-status-anim"></span>
            </button>
            <!-- for small cards only -->
            <div
              v-if="isCustomizable && smallCards && !isOnCartPage"
              class="cust-text mt5 ml0 color-grey"
              @click="$emit('addtocart')"
            >
              Customisable
            </div>

            <!-- v-if="isCustomizable && !smallCards" -->
            <div
              v-if="isCustomizable && !smallCards && !isOnCartPage"
              class="cust-text flex-row justify-content-center"
              @click="$emit('addtocart')"
            >
              Customisable
            </div>
            <div
              v-else-if="!isCustomizable && !smallCards && !isOnCartPage"
              class="cust-text-empty"
            ></div>
          </div>
        </div>
      </div>

      <!-- product price and Add cta -->
      <div
        class="selected-info no-margin align-items-center"
        :class="{ 'opacity-60': outOfStock, width35: isOnCartPage }"
        v-if="!outOfStock && isOnCartPage"
      >
        <div class="main-cta">
          <div
            v-if="quantity > 0"
            class="btn cta-edit medium"
            :class="{
              'cta-edit-cart': isOnCartPage,
            }"
          >
            <span
              class="anim-ico-minus item-status-anim"
              @click="$emit('removefromcart')"
            >
            </span>
            <span class="bg-white item-quantity">{{ quantity }}</span>
            <span
              class="anim-ico-plus item-status-anim"
              @click="!outOfStock && $emit('addtocart')"
            ></span>
          </div>

          <button
            v-if="quantity === 0 && !outOfStock"
            class="btn medium bold hand cta-add"
            @click="$emit('addtocart')"
          >
            Add
            <span
              class="anim-ico-plus item-status-anim"
              v-if="!smallCards"
            ></span>
          </button>
          <!-- for small cards only -->
          <div
            v-if="isCustomizable && smallCards && !isOnCartPage"
            class="cust-text mt5 ml0 color-grey"
            @click="$emit('addtocart')"
          >
            Customisable
          </div>
        </div>
        <div class="selections disp-col-inline">
          <div
            v-if="currentPrice === 0 || !currentPrice"
            class="width10 hide-shimmer-text shimmer-container rounded"
          >
            price
          </div>
          <div
            v-else-if="
              (discountedPrice === currentPrice || !discountedPrice) &&
              !discount
            "
            class="pl5"
          >
            <div
              v-if="regularPrice && currentPrice !== regularPrice"
              class="tr"
            >
              <span class="color-grey fs-10">
                <i class="rs">Rs.</i
                ><span class="striked-text"> {{ regularPrice }} </span>
              </span>
            </div>
            <div class="product-price">
              <i class="rs" v-if="currentPrice != 'Free'">Rs.</i>
              <span>
                {{ currentPrice }}
              </span>
            </div>
          </div>
          <div v-else class="pl5">
            <div
              v-if="currentPrice && currentPrice !== discountedPrice"
              class="tr"
            >
              <span class="color-grey fs-10">
                <i class="rs">Rs.</i
                ><span class="striked-text"> {{ currentPrice }} </span>
              </span>
            </div>
            <div class="product-price">
              <i class="rs" v-if="discountedPrice != 'Free'">Rs.</i>
              <span :class="{ 'color-error': discountedPrice == 'Free' }">
                {{ discountedPrice }}
              </span>
            </div>
          </div>

          <!-- v-if="isCustomizable && !smallCards" -->
          <div
            v-if="isCustomizable && !smallCards && !isOnCartPage"
            class="cust-text"
            @click="$emit('addtocart')"
          >
            Customisable
          </div>
        </div>
      </div>
      <div class="customizations border-bottom-light hide">
        <span class="color-base">Added:&nbsp;</span>
        <span class="color-grey"> cheese, chilly </span>
        <span class="color-base">Replaced:&nbsp;</span>
        <span class="color-grey"> cheese </span>
      </div>
    </div>
  </div>
</template>

<script setup>
import LazyImage from "./LazyImage.vue";
</script>

<script>
import { staticImgBaseUrl, clientPlatform } from "../config/apiEndpoints";
export default {
  name: "ProductCard",
  props: {
    smallCards: { required: true, default: false },
    isValid: { required: false, default: true },
    isOnCartPage: { required: false, default: false },
    showIconWithTitle: { required: false, default: false },
    quantity: { required: true, default: 0 },
    cardRounded: { required: false, default: false },
    cardSizeReorder: { required: false, default: false },
    hideProductImg: { required: false, default: false },
    imageSrc: { required: true, default: "" },
    isInModal: { required: false, default: false },
    isFavourite: { required: false, default: false },
    isVeg: { required: false, default: true },
    displayName: { required: true, default: "" },
    description: { required: false, default: "" },
    isComboItem: { required: false, default: false },
    currentPrice: { required: true, default: 0 },
    regularPrice: { required: false, default: 0 },
    isCustomizable: { required: false, default: false },
    productId: { required: false, default: "" },
    isProductInfoClickable: { required: false, default: false },
    showFullInfo: { required: false, default: false },
    selectedComboVariants: { required: false, default: [] },
    outOfStockComboVariants: { required: false, default: [] },
    bestsellerTag: { required: false, default: false },
    newTag: { required: false, default: false },
    outOfStock: { required: false, default: false },
    isLastInvalidItem: { required: false, default: false },
    savingAmt: { required: false, default: 0 },
    discountedPrice: { required: false, default: 0 },
    discount: { required: false, default: 0 },
    productAttributes: { required: false, default: [] },
    variantNoPadding: { required: false, default: false },
  },
  components: {},
  data() {
    return {
      staticImgBaseUrl: staticImgBaseUrl,
      clientPlatform,
      // showDetails: false,
    };
  },
  created() {},
  mounted() {
    // console.log("mounted ", this.productId);
  },
  updated() {
    // console.warn("updated product : ", this.productId);
  },
  methods: {
    handleImageError(event) {
      event.target.src =
        staticImgBaseUrl + "/images/global/hongs-default-img-lg-grey.jpeg";
      event.target.onerror = null;
    },
    // showComboDetails() {
    //   this.showDetails = !this.showDetails;
    // },
  },
  computed: {
    getPlaceHolderImg() {
      return staticImgBaseUrl + "/images/global/hongs-default-img-lg-grey.jpeg";
    },
    // showOrHideDetailsText() {
    //   return this.showDetails ? "Hide Details " : "Show Details ";
    // },
  },
};
</script>

<style scoped></style>
